document.addEventListener("DOMContentLoaded", function() {
    function getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    }

    function setCookie(name, value, days) {
        let expires = "";
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + (days*24*60*60*1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = `${name}=${value || ""}${expires}; path=/`;
    }

    function setLanguage() {
        const currentPath = window.location.pathname;
        const languages = {
            'en': '/en',
            'fr': '/fr',
            'de': '/de',
            'es': '/es',
        };
        const defaultLang = 'it';
        const cookieName = 'preferred_lang';

        function hasLanguagePrefix(path) {
            for (const langPrefix of Object.values(languages)) {
                if (path.startsWith(langPrefix + '/') || path === langPrefix) {
                    return true;
                }
            }
            return false;
        }

        const preferredLang = getCookie(cookieName);

        if (!hasLanguagePrefix(currentPath)) {
            let targetLang = preferredLang;

            if (!targetLang) {
                targetLang = (navigator.language || navigator.userLanguage || defaultLang).split('-')[0];
            }

            if (targetLang !== defaultLang && languages[targetLang]) {
                const newUrl = window.location.origin + languages[targetLang] + currentPath + window.location.search + window.location.hash;
                window.location.replace(newUrl);
            }
        }
    }

    // setLanguage();
});


window.addEventListener("load", function(){
    function calcMenuH() {
        const menu = document.querySelector("header");
        let menuh = 0;
        if (menu != null) {
            menuh = menu.offsetHeight;
        }
        return `${menuh}px`;
    }

    document.documentElement.style.setProperty('--menuh', calcMenuH());
    console.log("VespaEscape works, " + document.documentElement.style.getPropertyValue('--menuh'));

    const appEmbedElement = document.querySelector("#app-embed");

    if (appEmbedElement && appEmbedElement.shadowRoot) {
        const shadowRoot = appEmbedElement.shadowRoot;

        const fieldsetDiv = shadowRoot.querySelector("fieldset > div");

        if (fieldsetDiv) {
            fieldsetDiv.style.gridTemplateColumns = "1fr 1fr";
        }
    }

    function setPreferredLang(langCode) {
        document.cookie = `preferred_lang=${langCode}; path=/; max-age=${60*60*24*30}`; // 30 giorni
    }
});